/**
 * Lo que le falta a un alta para poder enviarse, dicho con palabras.
 *
 * El botón «Dar de alta» se apagaba sin decir por qué. El 13 oct 2026 alguien
 * tenía el formulario entero lleno y el botón gris: el número de contacto
 * llevaba doce dígitos y hacen falta diez. La pista del campo lo decía —«Diez
 * dígitos.»—, pero una pista no es un error, y nada la relacionaba con el botón.
 *
 * Es una función aparte, y no una condición dentro del modal, para que haya una
 * sola respuesta a «¿se puede enviar?»: el botón se enciende cuando esta lista
 * está vacía, y lo que el pie enseña es esta misma lista.
 */

/** Hasta cuántos huecos se nombran uno por uno; con más, se dice sólo cuántos. */
export const NAMED_GAPS = 3;

/** Los diez dígitos de un número nacional. El servidor exige lo mismo. */
export const PHONE_DIGITS = 10;

export const phoneDigits = (raw: string): string => raw.replace(/[^0-9]/g, '');

/** Por qué ese número no vale; `null` si vale o si todavía no se ha escrito. */
export const phoneError = (raw: string): string | null => {
  const digits = phoneDigits(raw).length;
  if (digits === 0 || digits === PHONE_DIGITS) return null;
  return `Son ${String(PHONE_DIGITS)} dígitos y lleva ${String(digits)}.`;
};

export interface IntakeDraft {
  readonly nameOk: boolean;
  readonly emailLocalPart: string;
  readonly subAreaId: string;
  readonly positionId: string;
  readonly hireDate: string;
  readonly workMode: string;
  readonly computerEquipment: string;
  readonly personalEmail: string;
  readonly personalPhone: string;
  readonly leaderPersonId: string;
}

/**
 * Lo que falta, en el orden en que está en el formulario.
 *
 * El sueldo no entra: es opcional al capturar y obligatorio al validar.
 */
export const intakeGaps = (draft: IntakeDraft): readonly string[] => {
  const phone = phoneError(draft.personalPhone);
  return [
    !draft.nameOk && 'el nombre',
    draft.subAreaId === '' && 'la sub área',
    draft.positionId.length === 0 && 'el puesto',
    draft.leaderPersonId.length === 0 && 'el jefe directo',
    draft.workMode === '' && 'la modalidad',
    draft.computerEquipment.trim().length === 0 && 'el equipo de cómputo',
    !draft.personalEmail.includes('@') && 'el correo personal',
    phoneDigits(draft.personalPhone).length === 0 && 'el número de contacto',
    phone !== null && `el número de contacto (${phone.replace(/\.$/, '').toLowerCase()})`,
    draft.hireDate.length === 0 && 'la fecha de ingreso',
    draft.emailLocalPart.trim().length === 0 && 'el correo corporativo',
  ].filter((gap): gap is string => typeof gap === 'string');
};
